import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/dataChart/index'
import Collection from '@/components/dataChart/collection'
import Achievement from '@/components/dataChart/achievement'
import Management from '@/components/dataChart/management'
import test from '@/components/dataChart/test'
import Business from '@/components/dataChart/business' //业务数据分析
import Personnel from '@/components/dataChart/personnel' //人员数据分析


Vue.use(Router)

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
//   mode:'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {//回款分析
      path: '/Collection',
      name: 'Collection',
      component: Collection
    },
    {//回款分析
      path: '/test',
      name: 'test',
      component: test
    },
    {//业绩分析
      path: '/Achievement',
      name: 'Achievement',
      component: Achievement
    },
    {//经营分析
      path: '/Management',
      name: 'Management',
      component: Management
    },
    {//数据分析
      path: '/Business',
      name: 'Business',
      component: Business
    },
    {//人员分析
      path: '/Personnel',
      name: 'Pusiness',
      component: Personnel
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js